module.exports = __webpack_public_path__ + "img/22.b3abb55d.png";